import type Result from 'true-myth/result';

import type { JobArchitecture } from '~/shared/data-contract/job-architecture';
import { jobArchitectureSchema } from '~/shared/data-contract/job-architecture';
import type { ValidatingHttpFetcherWithBaseUrl } from '~/shared/validating-http-fetcher';

export type CreateNewJobArchitecture = () => Promise<Result<JobArchitecture, Error>>;

export const createCreateNewJobArchitecture = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): CreateNewJobArchitecture => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return () => {
        return validatingCobrainerApiFetcher.postJson(jobArchitectureSchema, {
            pathname: `/job-architectures`,
            payload: {
                translations: [],
            },
        });
    };
};
